//Close Toggle for Contextual Alerts

jQuery( "body" ).on('click', '.fa-times', function(e) {
    var contextualAlert = jQuery(this).parents('.usa-alert');
    jQuery(contextualAlert).addClass('dNone');
});

jQuery( "body" ).on('click', '.fa-times', function(e) {
    var contextualAlert = jQuery(this).parents('.dol-alerts');
    jQuery(contextualAlert).addClass('dNone');
  });